import { useEffect } from "react";
import { useStores } from "stores";

export const usePendingStatistics = (userId: string | undefined) => {
  const { pendingStatistics, user } = useStores();

  const { isJuniorOperator, isSeniorOperator, isCustomer, isProvider, isLPRiskManager } = user.roles;

  const canLoadStatistics = isJuniorOperator || isSeniorOperator || isCustomer || isProvider || isLPRiskManager;

  useEffect(() => {
    if (userId && canLoadStatistics) {
      pendingStatistics.startPolling();
      return () => pendingStatistics.stopPolling();
    }
  }, [canLoadStatistics, pendingStatistics, userId]);

  return {
    indicators: pendingStatistics.indicators,
    isLoading: pendingStatistics.isLoading,
    error: pendingStatistics.error,
  };
};
